/* global module */
import { createStore, applyMiddleware, compose } from 'redux';
// import thunk from 'redux-thunk';
import setupDB from './database/setup';
// Middleware
import SessionsMiddleware from './middleware/sessions_middleware';

// Reducer
import rootReducer from './reducers';

const finalCreateStore = db => {
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose;

  const middleware = [SessionsMiddleware(db)];
  return composeEnhancers(
    // Middleware you want to use in development:
    applyMiddleware(...middleware)
  )(createStore);
};

export default async initProps => {
  const { columns, general, sessions, venue } = initProps;

  const db = await setupDB(sessions, venue);
  const composer = finalCreateStore(db);
  const store = composer(rootReducer, {
    columns,
    general,
    sessions: { ...sessions, items: db.sessions },
  });

  // /* istanbul ignore if  */
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers/index', async () => {
      const nextReducer = await import('./reducers/index');
      store.replaceReducer(nextReducer);
    });
  }

  return store;
};
